import { Injectable } from '@angular/core'
import { Action } from '@ngrx/store'
import { ChangeOwnershipModel } from '../pet-owner/change-ownership/Models/change-ownership-model';

export const LOAD_CHANGEOWNERSHIP = "[CHANGEOWNERSHIP] Load" 
export const CREATE_CHANGEOWNERSHIP = "[CHANGEOWNERSHIP] Create" 

export class LoadChangeownership implements Action{
    readonly type = LOAD_CHANGEOWNERSHIP
}

export class CreateChangeownership implements Action{
    readonly type = CREATE_CHANGEOWNERSHIP
    constructor(public payload: ChangeOwnershipModel) {}
}

export type Actions = LoadChangeownership | CreateChangeownership